import { useContext, useEffect, Profiler } from 'react';
import { connect } from 'react-redux';
import { I18N, Loading } from 'commons';
import { selectSignUpSubscriptions } from 'state/selectors/signUpSelectors';
import GroupMembershipList from './groupMembershipList';
import { getGroupMembershipList } from 'state/actions/groupMembershipActions';

import './groupMembershipList.scss';

const GroupMembershipSection = ({ groupMembershipList, isLoading, isGroupMembershipListFetched }) => {

    const onRender = (...args) => {
        console.log('GroupMembershipSection rendered', args);
    }

    useEffect(() => {
        if (!isLoading && !groupMembershipList?.length && !isGroupMembershipListFetched) {
            getGroupMembershipList();
        }
    }, []);

    if (isLoading && !isGroupMembershipListFetched) {
        return <Loading />
    }
    if (!isLoading && isGroupMembershipListFetched === true && !groupMembershipList?.length) {
        return <div className='no-content'><I18N>groupMembership.noContentFound</I18N></div>
    }

    return (
        <Profiler id='Group-Membership' onRender={onRender}>
            <div className='group-membership-section'>
                <GroupMembershipList groupMembershipList={groupMembershipList} />
            </div>
        </Profiler>

    );
}

const mapStateToProps = state => ({
    groupMembershipList: state.groupMembership.groupMembershipList,
    isLoading: state.groupMembership.isLoading,
    isGroupMembershipListFetched: state.groupMembership.isGroupMembershipListFetched,
})

const mapDispatchToProps = dispatch => ({
    getGroupMembershipList: (contactId) => dispatch(getGroupMembershipList.action({ contactId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupMembershipSection);
